import { render, staticRenderFns } from "./ClassicEditor.vue?vue&type=template&id=1e411023&"
import script from "./ClassicEditor.vue?vue&type=script&lang=js&"
export * from "./ClassicEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports